var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftsNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.5,7h-3.613c1.832-.879,3.113-2.355,3.113-4.5,0-.276-.224-.5-.5-.5s-.5.224-.5.5c0,3.063-3.271,4.189-5.839,4.442.779-.963,1.839-2.532,1.839-3.942,0-1.654-1.346-3-3-3s-3,1.346-3,3c0,1.41,1.059,2.978,1.839,3.942-2.568-.252-5.839-1.379-5.839-4.442,0-.276-.224-.5-.5-.5s-.5.224-.5.5c0,2.145,1.281,3.621,3.113,4.5h-3.613c-1.93,0-3.5,1.57-3.5,3.5v1c0,.827.673,1.5,1.5,1.5h.5v6.5c0,2.481,2.019,4.5,4.5,4.5h11c2.481,0,4.5-2.019,4.5-4.5v-6.5h.5c.827,0,1.5-.673,1.5-1.5v-1c0-1.93-1.57-3.5-3.5-3.5ZM12,1c1.103,0,2,.897,2,2,0,1.248-1.23,2.899-2,3.768-.77-.869-2-2.52-2-3.768,0-1.103.897-2,2-2ZM1,11.5v-1c0-1.378,1.122-2.5,2.5-2.5h8v4H1.5c-.276,0-.5-.224-.5-.5Zm2,8v-6.5h8.5v10h-5c-1.93,0-3.5-1.57-3.5-3.5Zm18,0c0,1.93-1.57,3.5-3.5,3.5h-5v-10h8.5v6.5Zm2-8c0,.276-.224.5-.5.5h-10v-4h8c1.378,0,2.5,1.122,2.5,2.5v1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftsNote);
export default __webpack_public_path__ + "static/media/GiftsNote.8acec8e0497f5a8263045d5dbc19d84f.svg";
export { ForwardRef as ReactComponent };